import { addStepProgressList } from '@/store/reducers/StepProgressStore';
import { FETCH_THREAD_STEP_PROGRESS } from '@/components/chat/chatThreadHooks';
import { getLayoverLogger } from '@/logging/LayoverLogger';
import { getStepProgressFromGraphQL } from '@/models/StepProgress';
import { client as gqlClient } from '@/api/GraphQLClient';
import { ThreadId } from '@/models/Thread';

import { createAsyncThunk } from '@reduxjs/toolkit';

export const fetchAllStepProgressForThread = createAsyncThunk(
  'data/fetchAllStepProgressForThread',
  async (threadId: ThreadId, { dispatch, rejectWithValue }) => {
    try {
      const { data, error } = await gqlClient.query({
        query: FETCH_THREAD_STEP_PROGRESS,
        variables: { threadId },
      });

      if (error) {
        getLayoverLogger().logError(
          'Error fetching thread step progress',
          error,
        );
      }

      const thread = data?.thread;
      const threadStepProgress = thread.latestStepProgress.map(
        (stepProgress: any) => getStepProgressFromGraphQL(stepProgress),
      );
      const messageStepProgress = thread.messages.edges
        .flatMap(({ node }: any) => node.latestStepProgress)
        .filter(Boolean)
        .map((stepProgress: any) => getStepProgressFromGraphQL(stepProgress));
      const allStepProgress = [...threadStepProgress, ...messageStepProgress];

      dispatch(addStepProgressList(allStepProgress));
    } catch (error) {
      if (error instanceof Error) {
        return rejectWithValue({ errorMessage: error.message });
      }

      throw error;
    }
  },
);
